import * as core from '../../../../../../../core'

import { query } from './open-assistant-metric.query'

export const RESOURCE = {
  payload: {
    alias: 'playground.open-assistant-metric',
    description:
      'A single button that opens the assistant slideout directly, with a ' +
      'fixed agent and no row-specific data',
    name: 'Playground - Open Assistant',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
